import { apiGet, apiPut } from '../client';
import {
  PayrollReportResponseSchema,
  StaffPayRateResponseSchema,
  type PayBasis,
  type PayrollReport,
  type StaffPayRate,
} from '../schemas';
import type { ReportRange } from './reports';

/** Finanzas > Reportes > Planilla. The CSV rides `downloadReportExport('planilla', range)`. */
export async function getPayrollReport(range: ReportRange): Promise<PayrollReport> {
  const query = new URLSearchParams({ from: range.from, to: range.to }).toString();
  const response = await apiGet(`/v1/business/reports/payroll?${query}`, PayrollReportResponseSchema);
  return response.data;
}

/**
 * A rate in integer cents and its basis, or both null to clear it. With
 * `expectedVersion` (the roster row's version the planilla read) a stale one
 * comes back 409 version_conflict.
 */
export type PayRateInput = ({ rateCents: number; basis: PayBasis } | { rateCents: null; basis: null }) & {
  expectedVersion?: number;
};

export async function putStaffPayRate(
  staffId: string,
  input: PayRateInput,
  idempotencyKey: string,
): Promise<StaffPayRate> {
  const response = await apiPut(
    `/v1/business/staff/${encodeURIComponent(staffId)}/pay-rate`,
    StaffPayRateResponseSchema,
    input,
    idempotencyKey,
  );
  return response.data;
}
